import getPathnameLocationUtil from 'utils/location/get-pathname'
import { ROUTE_PATH } from 'modules/route/constants'
import { COLLECTION_ID } from 'modules/collection/constants'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'

export default function isFeaturedJustDroppedUrlLocationUtil () {
  const pathname = getPathnameLocationUtil()
  const queryParams = getQueryParamsFromStringObjectUtil()
  return (
    pathname.startsWith(ROUTE_PATH.FEATURED_DEALS) &&
    queryParams.collection_id === COLLECTION_ID.JUST_DROPPED_MIXED.toString()
  )
}
